const indexItems = [
  { id: 1, label: '热血冒险', count: '2,341部', icon: 'ri-fire-line' },
  { id: 2, label: '恋爱甜宠', count: '1,892部', icon: 'ri-heart-line' },
  { id: 3, label: '玄幻修仙', count: '3,156部', icon: 'ri-moon-line' },
  { id: 4, label: '悬疑推理', count: '987部', icon: 'ri-search-eye-line' },
  { id: 5, label: '搞笑日常', count: '1,654部', icon: 'ri-emotion-laugh-line' },
  { id: 6, label: '都市职场', count: '1,203部', icon: 'ri-building-line' },
  { id: 7, label: '科幻未来', count: '876部', icon: 'ri-rocket-line' },
  { id: 8, label: '古风武侠', count: '2,089部', icon: 'ri-sword-line' },
  { id: 9, label: '恐怖灵异', count: '743部', icon: 'ri-ghost-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">漫画分类索引</h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            九大分类覆盖全题材，点击探索你喜欢的漫画世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="relative group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100/80 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-950 mb-1 group-hover:text-primary-500 transition-colors">
                {item.label}
              </h3>
              <span className="text-xs text-foreground-400">{item.count}</span>
              <div className="absolute top-4 right-4 w-5 h-5 flex items-center justify-center text-foreground-300 opacity-0 group-hover:opacity-100 transition-opacity">
                <i className="ri-arrow-right-up-line text-sm"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}